<section>
  <div class="header-box">
    <div class="logo">
      <img alt="purolator logo" src="assets/images/logo-purolator.gif" />
    </div>
    <div class="menu">
    
      <img alt="language" src="assets/images/language.svg" style="margin-right: -9px;">
      <a *ngIf="langLabel == 'fr'"  class="dropdown-item  cursor-pointer text-color-primary language-font" style="margin-right: 10px;"
         (click)="languageSwitch('en')" (keyup.enter)="languageSwitch('en')" tabindex="0"><span class="item" >{{ 'lang' | translate
                        }}</span></a>
      <a *ngIf="langLabel != 'fr'"  class="dropdown-item  cursor-pointer text-color-primary language-font" style="margin-right: 10px;"
         (click)="languageSwitch('fr')" (keyup.enter)="languageSwitch('fr')" tabindex="0"><span class="item" >{{ 'lang' | translate
                        }}</span></a>
    
        <div class="item">{{'SUPPORT_TEXT'|translate}}</div>
    </div>
  </div>
</section>
